import { Mail } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

export default function Autrice() {
  return (
    <section id="autrice" className="parchment-texture relative py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative mx-auto max-w-sm">
                <div className="absolute -inset-3 rounded-xl border border-gold/50" aria-hidden="true" />
                <img
                  src="/assets/autrice.jpg"
                  alt="Patrizia Franzina, autrice de Il Segreto del Lago"
                  className="relative block w-full rounded-lg object-cover shadow-xl"
                  style={{ aspectRatio: "4/5" }}
                  data-testid="author-portrait"
                />
                <p className="mt-4 text-center text-xs italic text-ink-muted">
                  Patrizia Franzina — Lago d'Orta
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <SectionHead light kicker="L'Autrice" title="Patrizia Franzina" />
            <Reveal delay={0.2}>
              <div className="mt-8 space-y-4 text-base leading-relaxed text-ink-dark/90" data-testid="author-bio">
                <p>
                  Patrizia Franzina nasce a Omegna nel 1968 e vive a San Maurizio d'Opaglio,
                  sulle rive del Lago d'Orta. Impiegata e madre di Marco e Matilde, per quasi
                  quindici anni è stata assessore comunale alla cultura e al turismo,
                  impegnandosi in prima persona nella tutela dell'ecosistema lacustre attraverso
                  il{" "}
                  <a
                    data-testid="bio-contratto-lago-link"
                    href="https://sites.google.com/view/contratto-lago-cusio/home-page"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-lake-teal underline decoration-gold decoration-2 underline-offset-4 transition-colors hover:text-ink-dark"
                  >
                    Contratto di Lago
                  </a>
                  . Da circa cinque anni è vicepresidente dell'associazione
                  «Un Filo per Natale», dove creatività e passione per l'hobbistica trovano
                  espressione.
                </p>
                <p>
                  La scrittura è da sempre la sua compagna silenziosa. È stata una breve e intensa
                  malattia a darle il coraggio di trasformare quel desiderio in un progetto
                  compiuto: il suo primo romanzo, ambientato sul Lago d'Orta e primo di una serie.
                </p>
                <blockquote className="border-l-2 border-gold pl-5 font-serif text-lg italic text-lake-teal">
                  «Perché scrivere, per Patrizia, è il modo più vero per restare. Per lasciare un
                  segno. Per dire: io ci sono.»
                </blockquote>
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-6 flex flex-wrap gap-2">
                {["Omegna, 1968", "San Maurizio d'Opaglio", "Contratto di Lago", "Vicepresidente «Un Filo per Natale»"].map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-lake-teal/40 px-4 py-1.5 text-xs font-medium text-lake-teal"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.4}>
              <div className="mt-8 flex flex-col gap-3">
                <a
                  data-testid="author-press-contact"
                  href="mailto:press@patriziafranzina.it"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-lake-teal underline decoration-gold decoration-2 underline-offset-4 transition-colors hover:text-ink-dark"
                >
                  <Mail className="h-4 w-4" />
                  press@patriziafranzina.it
                </a>
                <a
                  data-testid="bio-rinascita-lago-link"
                  href="https://lagodorta.cnr.it/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-lake-teal underline decoration-gold decoration-2 underline-offset-4 transition-colors hover:text-ink-dark"
                >
                  La rinascita del Lago d'Orta — la storia vera (CNR)
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
